import {createReducer} from 'redux-act';
import {
  CLEAR_BAD_ORDER,
  DELETE_BAD_DRIVER_RATING,
  DELETE_BAD_DRIVER_RATING_ERROR,
  DELETE_BAD_DRIVER_RATING_SUCCESS,
  GET_BAD_DRIVER_RATING,
  GET_BAD_DRIVER_RATING_ERROR,
  GET_BAD_DRIVER_RATING_SUCCESS,
  GET_BAD_ORDER_SUCCESS,
  RATE_BAD_DRIVER,
  RATE_BAD_DRIVER_ERROR,
  RATE_BAD_DRIVER_SUCCESS,
  SET_BAD_ORDER_DETAIL_LOADING,
  UPDATE_BAD_DRIVER_RATING,
  UPDATE_BAD_DRIVER_RATING_ERROR,
  UPDATE_BAD_DRIVER_RATING_SUCCESS,
  UPDATE_BAD_STATUS
} from 'store/bookADriver/bookADriverDetails/action';

const initialState = () => ({
  order: {},
  isLoading: false,
  rateDriverLoading: false,
  rateDriverError: null,
  driverRating: null,
  getDriverRatingLoading: false,
  updateDriverRatingLoading: false,
  deleteDriverRatingLoading: false
});

const bookADriverOpenDetails = createReducer(
  {
    [GET_BAD_ORDER_SUCCESS]: (state, payload) => ({
      ...state,
      order: payload,
      isLoading: false
    }),
    [SET_BAD_ORDER_DETAIL_LOADING]: (state, payload) => ({
      ...state,
      isLoading: payload
    }),
    [UPDATE_BAD_STATUS]: (state, payload) => {
      return {
        ...state,
        order: {
          ...state.order,
          data: {
            ...state.order.data,
            status: payload
          }
        }
      };
    },
    [RATE_BAD_DRIVER]: (state) => ({
      ...state,
      rateDriverLoading: true,
      rateDriverError: null
    }),
    [RATE_BAD_DRIVER_SUCCESS]: (state, payload) => ({
      ...state,
      rateDriverLoading: false,
      rateDriverError: null,
      driverRating: payload
    }),
    [RATE_BAD_DRIVER_ERROR]: (state, payload) => ({
      ...state,
      rateDriverLoading: false,
      rateDriverError: payload
    }),
    [GET_BAD_DRIVER_RATING]: (state) => ({
      ...state,
      getDriverRatingLoading: true
    }),
    [GET_BAD_DRIVER_RATING_SUCCESS]: (state, payload) => ({
      ...state,
      driverRating: payload,
      getDriverRatingLoading: false
    }),
    [GET_BAD_DRIVER_RATING_ERROR]: (state) => ({
      ...state,
      getDriverRatingLoading: false
    }),
    [UPDATE_BAD_DRIVER_RATING]: (state) => ({
      ...state,
      updateDriverRatingLoading: true
    }),
    [UPDATE_BAD_DRIVER_RATING_SUCCESS]: (state, payload) => ({
      ...state,
      driverRating: payload,
      updateDriverRatingLoading: false
    }),
    [UPDATE_BAD_DRIVER_RATING_ERROR]: (state) => ({
      ...state,
      updateDriverRatingLoading: false
    }),
    [DELETE_BAD_DRIVER_RATING]: (state) => ({
      ...state,
      deleteDriverRatingLoading: true
    }),
    [DELETE_BAD_DRIVER_RATING_SUCCESS]: (state) => ({
      ...state,
      driverRating: null,
      deleteDriverRatingLoading: false
    }),
    [DELETE_BAD_DRIVER_RATING_ERROR]: (state) => ({
      ...state,
      deleteDriverRatingLoading: false
    }),
    [CLEAR_BAD_ORDER]: (state) => ({
      ...state,
      order: {},
      driverRating: null,
      rateDriverError: null
    })
  },
  initialState()
);

export default bookADriverOpenDetails;
